import { Link, useLocation } from "react-router-dom";
import { findNavItem } from "@/pages/admin/navConfig";

export default function ModulePlaceholder() {
  const location = useLocation();
  const match = findNavItem(location.pathname);
  const item = match?.item;
  const group = match?.group;

  return (
    <div>
      <div className="mb-6 md:mb-8">
        <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-foreground-500">
          {group?.heading || "Module"}
        </p>
        <h1 className="font-heading text-3xl md:text-4xl text-foreground-950 font-semibold mt-2">
          {item?.label || "Module"}
        </h1>
      </div>

      <div className="bg-background-50 border border-background-200 rounded-lg p-7 md:p-12 max-w-3xl">
        <span className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-700">
          <i className={`${item?.icon || "ri-tools-line"} text-2xl`}></i>
        </span>
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 font-semibold mt-5">
          This module is on the roadmap
        </h2>
        <p className="text-sm md:text-base text-foreground-600 leading-relaxed mt-3 max-w-xl">
          {group?.blurb}
        </p>

        <div className="flex flex-wrap items-center gap-3 mt-6">
          <span className="inline-flex items-center gap-2 text-xs font-semibold text-secondary-800 bg-secondary-100 border border-secondary-200 px-3 py-1.5 rounded-full">
            <i className="ri-time-line"></i>
            Planned for Phase {item?.phase || 6}
          </span>
          <span className="inline-flex items-center gap-2 text-xs font-semibold text-accent-900 bg-accent-100 border border-accent-300 px-3 py-1.5 rounded-full">
            <i className="ri-hammer-line"></i>
            In development
          </span>
        </div>

        <div className="flex flex-wrap gap-3 mt-8">
          <Link
            to="/admin/bookings"
            className="inline-flex items-center gap-2 bg-primary-500 text-background-50 text-sm font-semibold px-5 py-3 rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-calendar-check-line"></i>
            Go to Bookings
          </Link>
          <Link
            to="/admin"
            className="inline-flex items-center gap-2 border border-background-300 text-foreground-800 text-sm font-semibold px-5 py-3 rounded-md hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-dashboard-line"></i>
            Back to Dashboard
          </Link>
        </div>
      </div>
    </div>
  );
}